import styled from "styled-components";

const FormFieldContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
`;

export default FormFieldContainer;
